var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 7,
    viewBox: "0 0 4 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.354 3.1582C3.354 3.24479 3.32096 3.32227 3.25488 3.39062L0.547852 6.03613C0.518229 6.06576 0.485189 6.08854 0.44873 6.10449C0.409993 6.12044 0.368978 6.12842 0.325684 6.12842C0.266439 6.12842 0.212891 6.11475 0.165039 6.0874C0.117187 6.06006 0.0795898 6.0236 0.052246 5.97803C0.0249023 5.93018 0.0112304 5.87663 0.0112304 5.81738C0.0112304 5.73079 0.0408528 5.65674 0.100098 5.59521L2.77637 2.97705L2.77637 3.34277L0.100097 0.724609C0.0408526 0.660807 0.0112302 0.586751 0.0112302 0.502441C0.0112302 0.443197 0.0249021 0.390788 0.0522458 0.345215C0.0795896 0.297363 0.117187 0.259766 0.165039 0.232422C0.21289 0.205078 0.266439 0.191406 0.325683 0.191406C0.409993 0.191406 0.48291 0.222168 0.544433 0.283691L3.25488 2.9292C3.28678 2.95882 3.31185 2.99414 3.33008 3.03516C3.34603 3.07389 3.354 3.11491 3.354 3.1582Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.71c26b8fd787b93e3a6b3aab00ba7447.svg";
export { ForwardRef as ReactComponent };